import { axios, BaseApiUrl,BaseUrl} from '../axios_config';
//查询基础数据
export const getFeeItemBatchBasis = params => {
    return axios.get(`${BaseApiUrl}/ExpenseSetting/GetFeeItemBatchBasis`, { params: params });
};
//查询规则模板
export const getFeeRuleTemplateByFeeRuleId = params => {
    return axios.get(`${BaseApiUrl}/ExpenseSetting/GetFeeRuleTemplateByFeeRuleId`, { params: params });
};

//查询费用设置详情
export const getFeeItemBatchByFeeItemBatchId = params => {
    return axios.get(`${BaseApiUrl}/ExpenseSetting/GetFeeItemBatchByFeeItemBatchId`, { params: params });
};
//新增修改费用配置
export const AddFeeItemBatch = params => {
    return axios.post(`${BaseApiUrl}/ExpenseSetting/AddFeeItemBatch`, params);
};

//查询费用配置
export const getFeeItemBatchAsync = params => {
    return axios.post(`${BaseApiUrl}/ExpenseSetting/GetFeeItemBatchAsync`, params);
};

//导出费用配置
export const exportFeeItemBatchAsyncOut = `${BaseApiUrl}/ExpenseSetting/FeeItemBatchAsyncOut`;

//审核费用规则
export const examineFeeItemBatchStatus = params => {
    return axios.get(`${BaseApiUrl}/ExpenseSetting/ExamineFeeItemBatchStatus`, { params: params });
};

//启用/禁用费用规则
export const examineFeeItemBatchIsStart = params => {
    return axios.get(`${BaseApiUrl}/ExpenseSetting/ExamineFeeItemBatchIsStart`, { params: params });
};

//重算费用
export const recostingFeeFlowDetail = params => {
    return axios.get(`${BaseApiUrl}/ExpenseSetting/RecostingFeeFlowDetail`, { params: params });
};